<script setup lang="ts">
import { useUiStore } from '@/store/uiStore';

const uiStore = useUiStore();

function unlocker(value: 0 | 1 | 2) {
  if (!uiStore.unlockFn) {
    return;
  }
  uiStore.unlockFn(value);
}
</script>

<template>
  <div class="ui-lock">
    <span class="title">{{ $t('message.saveDiscardChanges') }}</span>

    <div class="button-row">
      <UiButton variant="error" block expand @click="unlocker(1)">
        {{ $t('button.discard') }}
      </UiButton>
      <UiButton variant="primary" block expand @click="unlocker(2)">
        {{ $t('button.save') }}
      </UiButton>
    </div>

    <UiButton block expand variant="flat" @click="unlocker(0)">
      {{ $t('button.cancel') }}
    </UiButton>
  </div>
</template>

<style scoped lang="scss">
.ui-lock {
  padding: var(--space-24);
  border: 1px solid #ddd;
  border-radius: var(--border-radius-14);
  text-align: center;
  background-color: #f8f8f8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: px(380);
  border: var(--color-error-600) 1px solid;
  color: var(--color-gray-700);
  flex-flow: row-reverse;
}

.title {
  font-size: var(--font-size-18);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-10);
}

.button-row {
  display: flex;
  gap: var(--space-16);
  padding: var(--space-32) var(--space-16) 0 0;
  align-items: center;
  width: 100%;
}
</style>
